export const API_BASE_URL = 'https://api.macoapp.ca'

export const WS_URL = 'wss://api.macoapp.ca/ws/'

export const DEFAULT_LIMIT = 24
